import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { DbService } from '../../db.service';
import { SessionService } from '../../session.service';
import { SpinnerService } from '../../spinner.service';

import { Login, RecSenha, ViewRetornoRecSenha } from './login.class'
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common';

declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
    selector: 'app-login-modal',
    templateUrl: './app-login.component.html',
    styleUrls: ['./app-login.component.css']
})

export class AppLoginModalComponent {
    @ViewChild(ModalDirective) modal: ModalDirective;
    @Output() eventUpdate =  new EventEmitter();
    form: FormGroup;
    formRecSenha: FormGroup;   
    resetValido: boolean = false;
    resetInvalido: boolean = false;
    item: Login = new Login();
    showErro: boolean = false;
    showRecSenha: boolean = false;
    isLoading: boolean = false;
    origem: string = 'header';
    etapa: number = 0;

    constructor(
        private dbService: DbService,
        private router: Router,
        private sessionService: SessionService,
        private spinnerService: SpinnerService
    ) {
        this.form = new FormGroup({
            dsEmail: new FormControl('', [Validators.required, Validators.email]),
            cdSenha: new FormControl('', Validators.required)
        });

        this.formRecSenha = new FormGroup({
            dsRecEmail: new FormControl('', [Validators.required, Validators.email]),

        });
    }

    fnEntrar() {
        // Valida formulário
        if (!this.form.valid) {
            // Exibe erros
            for (let ctrl in this.form.controls) { this.form.controls[ctrl].markAsTouched(); }
        } else {
            
            this.isLoading = true;
            this.dbService.post('Login', this.item).subscribe(result => {
                // Encerra spinner
                this.spinnerService.stop();
                this.isLoading = false;

                if (result.otpRequired === true) {
                    // Two-factor: redirect to OTP verification screen
                    this.modal.hide();
                    this.router.navigate(['/verificar-otp'], {
                        queryParams: {
                            email: this.item.dsEmail,
                            origem: this.origem,
                            etapa: this.etapa
                        }
                    });
                    return;
                }

                if (result.autenticado === true) {
                    this.sessionService.usuario.hash = result.hash;
                    this.sessionService.usuario.nmUsuario = result.nmUsuario;
                    this.sessionService.usuario.idUsuario = +result.idUsuario;
                    this.sessionService.usuario.lstRelatorios = result.lstRelatorios;
                    this.sessionService.usuario.nrRelatorios = result.lstRelatorios ? result.lstRelatorios.length : 0;
                    this.sessionService.fnSetSessao();

                    //EGS 30.03.2022 Google Analitics Log de login
                    gtag('config', environment.googleAnalyticsId, {});
                    gtag('event', 'login_realizado', {'method': ''});

                    this.modal.hide();

                    if (this.origem === 'planos'){
                        this.etapa =- 1;
                        this.eventUpdate.emit(this.etapa);
                    }
                    
                    //location.reload();

                } else {
                    this.showErro = true;
                }
            }, () => {
                this.spinnerService.stop();
                this.isLoading = false;
                this.showErro = true;
            });
        }
    }

    fnPlanos() {
        this.modal.hide();
        this.router.navigate(['/sobre/planos']);
        
        //EGS 30.11.2020 Envia email da compra para Debug em HML
      //this.dbService.get('Assinatura/RetornoCieloEGS').subscribe(result => {});        

    }

    fnShow(area: string = 'header', etapa: number = 0, email: string = '') {
        this.origem = area;
        this.etapa = etapa;
        this.item = new Login();
        this.formRecSenha.controls['dsRecEmail'].setValue(email);
        this.form.reset();
        this.modal.show();
    }

    fnShowRecuperarSenha() {
        this.showRecSenha = true;

    }
    fnHideRecuperarSenha() {
        this.showRecSenha = false;

    }

    fnRecuperarSenha() {

        // Valida formulário
        if (!this.formRecSenha.valid) {
            // Exibe erros
            for (let ctrl in this.formRecSenha.controls) { this.formRecSenha.controls[ctrl].markAsTouched(); }
        } else {

            let recSenha = new RecSenha();

            recSenha.dsRecEmail = this.formRecSenha.controls['dsRecEmail'].value;

            this.dbService.post('Login/RecuperarSenha', recSenha).subscribe((result: ViewRetornoRecSenha) => {
                if (result.validaSenha === true) {

                   this.resetValido = true;
                   this.resetInvalido= false;

                } else {
                    
                    this.resetValido = false;
                    this.resetInvalido= true;

                }
            });
        }
    }
}
